import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=1ced0616&"
import script from "./PromotionCard.vue?vue&type=script&lang=js&"
export * from "./PromotionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports